import PropTypes from 'prop-types';
import styles from './table-column-header.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { getTextColor } from '../../../utils/sharedHelpers';

const className = augmentClassName(styles);

const TableColumnHeader = ({ sortingState, sortString, sortLabel, lineTwo = '', sup = '', lineThree = '' }) => {

  if (lineTwo && sup && lineThree) {
    return (
      <div {...className(getTextColor(sortString, sortingState))}> {sortLabel}
        <p {...className('my-0')}>
          <span {...className('text-one-line')}>
            {lineTwo} <sup> {sup} </sup> /
          </span>
        </p>
        <p {...className('my-0')}>
          {lineThree}
        </p>
      </div>
    );
  } else if (lineTwo && sup) {
    return (
      <div {...className(getTextColor(sortString, sortingState))}> {sortLabel}
        <p {...className('my-0')}>
          <span {...className('text-one-line')}>
            {lineTwo} <sup> {sup} </sup>
          </span>
        </p>
      </div>
    );
  } else if (lineTwo) {
    return (
      <div {...className(getTextColor(sortString, sortingState))}> {sortLabel}
        <p {...className('my-0')}>
          {lineTwo}
        </p>
      </div>
    );
  } else if (sup) {
    return (
      <div {...className(getTextColor(sortString, sortingState))}>
        <span {...className('text-one-line')}>
          {sortLabel} <sup> {sup} </sup>
        </span>
      </div>
    );
  }

  return (
    <span {...className(getTextColor(sortString, sortingState))}> {sortLabel} </span>
  );

};

TableColumnHeader.propTypes = {
  sortingState: PropTypes.object,
  sortString: PropTypes.string,
  sortLabel: PropTypes.string,
  lineTwo: PropTypes.string,
  sup: PropTypes.number,
  lineThree: PropTypes.string
};

export default TableColumnHeader;
